import React, { useState } from "react";
import { Link } from "react-router-dom";

import { ACCENT, INPUT_CLASS, SUBMIT_CLASS } from "../Auth/authStyles";

const HEADING = "Forgot password";
const SUBCOPY = "Enter your email and we'll send you a reset link.";
const LOGIN_PROMPT = "Remembered it?";

const FEEDBACK_CLASS = {
  error: "border-[#d92d20]/25 bg-[#d92d20]/[0.06] text-[#d92d20]",
  success: "border-accent-on-light/25 bg-accent/[0.06] text-accent-on-light",
};

const ForgotPassword = ({ onSubmit, feedback }) => {
  const [valid, setValid] = useState();
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      setValid(2); // Update valid state to 2 to display the error message
      return;
    }

    setValid(1); // Update valid state to 1 if email is valid
    setSubmitting(true);
    try {
      await onSubmit(email);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="w-full bg-white relative overflow-hidden">
      <div className="relative z-10 max-w-xl mx-auto px-4 md:px-10 pt-4 pb-10 md:pt-5 md:pb-16">
        <div className="rounded-3xl border border-black/10 bg-white p-3 md:p-4 shadow-[0_40px_80px_-32px_rgba(27,10,68,0.22)]">
          <div className="flex flex-col !flex-nowrap !justify-center px-4 py-8 md:px-10 md:py-10">
            <h1 className="font-headline font-bold tracking-tight text-[#111113] text-[clamp(1.9rem,3.4vw,2.75rem)] leading-[1.12] m-0">
              {HEADING}
            </h1>

            <p className="font-body text-sm text-[#4a4753] mt-3 mb-0">
              {SUBCOPY}
            </p>

            <p className="font-body text-sm text-[#4a4753] mt-1.5 mb-0">
              {LOGIN_PROMPT}{" "}
              <Link
                to="/user/login"
                style={{ color: ACCENT }}
                className="underline underline-offset-4 hover:opacity-70 transition-opacity"
              >
                Log in
              </Link>
            </p>

            <form
              onSubmit={handleSubmit}
              className="flex flex-col !flex-nowrap gap-3 mt-8"
            >
              <input
                placeholder="you@example.com"
                aria-label="Email"
                autoComplete="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className={INPUT_CLASS}
              />

              {valid === 2 && (
                <p className="font-body text-[13px] text-[#d92d20] m-0">
                  Enter email
                </p>
              )}

              {feedback && (
                <p
                  role="status"
                  className={`font-body text-[13px] leading-relaxed rounded-md border px-4 py-3 m-0 ${
                    FEEDBACK_CLASS[feedback.type]
                  }`}
                >
                  {feedback.text}
                </p>
              )}

              <button
                type="submit"
                disabled={submitting}
                className={`${SUBMIT_CLASS} mt-3 disabled:opacity-60 disabled:cursor-not-allowed`}
              >
                {submitting ? (
                  <>
                    <span className="w-4 h-4 rounded-full border-2 border-[#1b0a44]/30 border-t-[#1b0a44] animate-spin" />
                    Sending
                  </>
                ) : (
                  <>
                    <span className="inline-block group-hover:translate-x-1 transition-transform duration-300">
                      Submit
                    </span>
                    <span className="material-symbols-outlined text-[18px] group-hover:animate-arrow-slide">
                      arrow_forward
                    </span>
                  </>
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
